module.exports = __webpack_public_path__ + "img/sexology.ff8f5f16.png";